import styled from 'styled-components';

import { Breakpoint, Color, FontWeight } from '../../../enums';
import { StyledComponent } from '../../../interfaces';

export const Container: StyledComponent<'div'> = styled.div``;

export const InnerContainer: StyledComponent<'div'> = styled.div`
  padding: 24px;
  border: 1px solid ${Color.Gray300};
`;

export const TopSection: StyledComponent<'div'> = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 24px;
  border-bottom: 1px solid ${Color.Gray300};
`;

export const BadgesContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-right: 10px;
`;

export const ContentSection: StyledComponent<'div'> = styled.div`
  padding-top: 24px;
`;

export const MobileEditButton: StyledComponent<'button'> = styled.button`
  font-weight: ${FontWeight.Medium};
  font-size: 16px;
  line-height: 22px;
  color: ${Color.Black};
  padding: 16px 0 18px;
  border: 1px solid ${Color.Gray300};
  border-top: 0;
  width: 100%;
  text-align: center;
  display: none;

  @media ${Breakpoint.SmallMobile} {
    display: block;
  }
`;
